<div class="p-16" [ngClass]="sale ? 'qr-shadow' : ''">
    <app-send-package-sms [sale]="sale" (sendLink)="onSendLink()"></app-send-package-sms>
</div>


<ng-template #sendGiviModal let-modal>
    <div class="modal-body" style="background-color: white; border-radius: 15px;">
        <app-send-package-link [sale]="sale"></app-send-package-link>
        <div class="d-flex-center p-b-24 m-t-10">
            <a class="font-14 text-muted" (click)="onClose()">VOLVER</a>
        </div>
    </div>
</ng-template>